/* eslint-disable react/jsx-filename-extension */
/* eslint-disable max-len */
import React from "react";
import Discuss from "parts/Discuss";
import Button from "elements/Button";
import BenefitsSection from "components/BenefitsSection";

export default function CybersecurityServices() {
  return (
    <>
      {/* HERO SECTION */}
      {/* لو عندك UniversalHero حطه هنا */}

      {/* FEATURES SECTION */}
      <section className="py-20 bg-premium-light">
        <div className="container mx-auto px-6">
          <h2 className="text-3xl lg:text-4xl text-surface-900 font-extrabold text-center mb-6 tracking-tight">
            Our Cybersecurity Coverage
          </h2>
          <p className="text-center text-surface-300 text-lg mb-12">
            We protect your business with multi-layered security built for modern threats.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="glass-card-static p-6 rounded-2xl">
              <h3 className="text-xl font-semibold text-surface-900 mb-2">
                24/7 Threat Monitoring
              </h3>
              <p className="text-surface-300 leading-relaxed">
                Real-time detection and response to suspicious activity across your entire environment.
              </p>
            </div>

            <div className="glass-card-static p-6 rounded-2xl">
              <h3 className="text-xl font-semibold text-surface-900 mb-2">
                Advanced Endpoint Protection
              </h3>
              <p className="text-surface-300 leading-relaxed">
                AI-powered antivirus, ransomware protection, and behavioral threat analysis.
              </p>
            </div>

            <div className="glass-card-static p-6 rounded-2xl">
              <h3 className="text-xl font-semibold text-surface-900 mb-2">
                Security Awareness Training
              </h3>
              <p className="text-surface-300 leading-relaxed">
                Reduce risks with training that helps your employees identify and avoid cyber threats.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* BENEFITS SECTION (Reusable) */}
      <BenefitsSection
        title="Why Cybersecurity Matters"
        subtitle="Cyber threats are constantly evolving — proactive protection is no longer optional."
        benefits={[
          {
            id: "data-protection",
            title: "Protect Your Business Data",
            text: "Keep sensitive information secure from ransomware, breaches, and internal threats.",
            delay: 0,
          },
          {
            id: "business-continuity",
            title: "Ensure Business Continuity",
            text: "Minimize downtime and operational interruptions caused by cyberattacks.",
            delay: 120,
          },
          {
            id: "compliance",
            title: "Meet Compliance Requirements",
            text: "Stay compliant with industry regulations and protect your organization from penalties.",
            delay: 240,
          },
        ]}
        gainsTitle="What You’ll Gain"
        gains={[
          { id: "detection", text: "Improved threat detection" },
          { id: "reduced-risk", text: "Reduced likelihood of breaches" },
          { id: "awareness", text: "Greater employee awareness" },
          { id: "posture", text: "Enhanced security posture" },
        ]}
      />

      {/* CTA SECTION */}
      <section className="py-20 bg-premium-accent">
        <div className="container mx-auto px-6 flex flex-col lg:flex-row items-center justify-between gap-6">
          <div>
            <h2 className="text-2xl lg:text-3xl text-surface-900 font-extrabold tracking-tight">
              Ready to Secure Your Business?
            </h2>
            <p className="text-surface-300 mt-2 text-lg">
              Let us build a cybersecurity strategy tailored to your needs.
            </p>
          </div>

          <Button
            href="/contact"
            type="link"
            className="btn-premium text-base px-8 py-4"
          >
            Book a Consultation
          </Button>
        </div>
      </section>

      <Discuss />
    </>
  );
}
